import { Component, Input, OnInit } from '@angular/core';
import { ViewStudentsViewItem } from 'edu-application/dist/students/view-students/view-students.viewmodel';

@Component({
  selector: 'student-details',
  templateUrl: './student-details-card.component.html',
  styleUrls: ['./student-details-card.component.scss']
})
export class StudentDetailsCardComponent implements OnInit {
  @Input() student: ViewStudentsViewItem;
  constructor() { }

  ngOnInit(): void {
  }

  getDeviceIcon(deviceType: string): string {
    switch (deviceType?.toLowerCase()) {
      case 'mobile':
        return 'smartphone';
      case 'tablet':
        return 'tablet';
      case 'desktop':
        return 'computer';
      case 'laptop':
        return 'laptop';
      default:
        return 'devices_other';
    }
  }
}
